import { FaFilter, FaRegWindowClose } from "react-icons/fa";

function Filter(props: any) {
    return (
        <div className="flex flex-row font-normal text-sm">
            <button type="button" className={`flex mr-2 ${props.activeFilters.enabled ? 'btn-filter-active' : 'btn-filter'} items-center`} onClick={props.toggleFilters}>
                <FaFilter className="mr-2"/> Toggle Filters
            </button>
            <button type="button" className="flex btn-clear-filter items-center" onClick={props.clearFilters}>
                <FaRegWindowClose className="mr-2"/> Close Filters
            </button>
        </div>
    );
};
export default Filter;